import IconClose from "@tvg/fuse-icons/lib/Close";
import useGlobalContext from "client/context/GlobalContext";
import React from "react";
import { StyledPlainIconButton } from "./close-button.styles";

interface CloseButtonProps {
  dataTestId?: string;
  children?: React.ReactNode;
}

const CloseButton: React.FC<CloseButtonProps> = ({
  dataTestId,
  children,
}: CloseButtonProps) => {
  const { closeModal } = useGlobalContext();

  return (
    <StyledPlainIconButton
      ariaLabel="Close search"
      callback={closeModal}
      icon={<IconClose />}
      size="small"
      srLabel="Close search"
      color="var(--color-greys-grey8)"
      dataTestId={dataTestId}
    >
      {children}
    </StyledPlainIconButton>
  );
};

export default React.memo(CloseButton);
